import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AlertBox(props) {
  const { color, icon, title, className } = props;

  return (
    <div
      className={`alert alert-${color} p-1 w-100${className ? ` ${className}` : " mb-0"}`}
    >
      {title ? (
        <div className="d-flex flex-column">
          <h6 className="my-1">
            <FontAwesomeIcon icon={icon} className="fa-fw mx-2" />
            {title}
          </h6>
          <div className="d-flex flex-row">
            <FontAwesomeIcon icon={icon} className="icon-invisible fa-fw mx-2" />
            <div className="my-auto" style={{ fontSize: "0.9rem" }}>
              {props.children}
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex flex-row">
          <div className="my-auto align-middle">
            <FontAwesomeIcon icon={icon} className="fa-fw mx-2" />
          </div>
          <div className="flex-grow-1 my-auto" style={{ fontSize: "0.9rem" }}>
            {props.children}
          </div>
        </div>
      )}
    </div>
  );
}
